module.exports = __webpack_public_path__ + "static/error-404-6e26e5a827754fa3c112671325113a7b.jpg";